<template>
  <v-hover v-slot:default="{hover}">
    <v-card :class="{ 'on-hover': hover}">
      <v-img
        :src="(service.image)?$assets.url(service.image.url):'#'"
        class="white--text align-center text-center"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        height="240px"
      >
        <div
          class="d-flex flex-column transition-fast-in-fast-out v-card--not-reveal white--text"
          style="height: 100%;"
        >
          <p class v-if="!hover">{{ service.name }}</p>
          <div v-if="!hover" v-html="service.priceLabel"></div>
        </div>
        <v-expand-transition>
          <div
            class="d-flex flex-column transition-fast-in-fast-out v-card--reveal white--text"
            style="height: 100%;"
            v-if="hover"
          >
            <p class>{{ service.name }}</p>
            <p class>{{ service.description }}</p>
            <v-btn x-small class="themed" dark :to="'/services/view/'+service.id">Choisir</v-btn>
          </div>
        </v-expand-transition>
      </v-img>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.serviceCard {
  &__body {
    position: relative;

    img {
      width: 100%;
    }
  }
}
.v-card--reveal,
.v-card--not-reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.v-card--reveal {
  background-color: rgba(10, 37, 44, 0.4);
}
.v-card--not-reveal {
  background-color: rgba(10, 37, 44, 0.4);
}
</style>